import { TextInput } from "@narmi/design_system";

interface SearchInputProps {
  onChange: (value: string) => void;
  placeholder: string;
  autoFocus?: boolean;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  value: string;
}

const SearchInput = ({
  onChange,
  placeholder,
  autoFocus = false,
  onKeyDown,
  value
}: SearchInputProps) => (
  <TextInput
    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
      onChange(e.target.value ?? "")
    }
    autoFocus={autoFocus}
    onKeyDown={onKeyDown}
    value={value}
    placeholder={placeholder}
    showClearButton
  />
);

SearchInput.displayName = "SearchInput";

export default SearchInput;
